import { useSelfQuery } from '../graphql/types';

export const useHasHpcMembers = () => {
  const { data } = useSelfQuery();

  return Boolean(data?.self?.coachData?.hasHpcMembers);
};
